module.exports = __webpack_public_path__ + "img/cable-internet.6348a7d5.png";